import { apiService } from './apiService';

export interface City {
  id: number;
  name: string;
  name_ascii: string;
  plaka: number;
}

export interface District {
  id: number;
  name: string;
  name_ascii: string;
}

export interface Neighborhood {
  id: number;
  name: string;
  name_ascii: string;
}

export const citiesService = {
  async getAll() {
    return await apiService.get('/cities');
  },

  async getDistricts(cityId: number) {
    return await apiService.get(`/cities/${cityId}/districts`);
  },

  async searchCities(q: string) {
    return await apiService.get(`/cities/search?q=${encodeURIComponent(q)}`);
  },

  async searchDistricts(q: string, cityId?: number) {
    let url = `/cities/districts/search?q=${encodeURIComponent(q)}`;
    if (cityId) url += `&cityId=${cityId}`;
    return await apiService.get(url);
  },

  async getNeighborhoods(districtId: number) {
    return await apiService.get(`/cities/districts/${districtId}/neighborhoods`);
  },

  async searchNeighborhoods(q: string, districtId?: number, cityId?: number) {
    let url = `/cities/neighborhoods/search?q=${encodeURIComponent(q)}`;
    if (cityId) url += `&cityId=${cityId}`;
    if (districtId) url += `&districtId=${districtId}`;
    return await apiService.get(url);
  }
};
